import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { Activity, TrendingUp, Clock } from 'lucide-react';
const steps = [{
  number: '01',
  icon: Activity,
  label: 'THE BODY',
  time: '90 seconds',
  title: 'Survival Mode vs. Regulated Peace.',
  desc: 'Before your mind can argue, your body already knows. Learn to read the difference between a dysregulated nervous system screaming in fear and the quiet signal of genuine spiritual peace.',
  colorClasses: {
    badge: 'bg-green-500/10 text-green-400 border-green-500/20',
    icon: 'text-green-400'
  }
}, {
  number: '02',
  icon: TrendingUp,
  label: 'THE FRUIT',
  time: '2 minutes',
  title: 'Trajectory, Not Promises.',
  desc: "Emotions lie in the moment. Fruit doesn't. Analyze where this relationship path actually leads in 6 months — not where you hope it goes. The fruit never lies.",
  colorClasses: {
    badge: 'bg-yellow-400/10 text-yellow-400 border-yellow-400/20',
    icon: 'text-yellow-400'
  }
}, {
  number: '03',
  icon: Clock,
  label: 'THE TIMING',
  time: '1 minute',
  title: 'Green, Yellow, and Red Signals.',
  desc: "Not every right decision has a right-now timing. Recognize God's signals: Green (move forward with confidence), Yellow (wait 24–72 hours), Red (pause — do not decide today).",
  colorClasses: {
    badge: 'bg-red-500/10 text-red-400 border-red-500/20',
    icon: 'text-red-400'
  }
}];
export function FrameworkSection() {
  return <section className="py-24 md:py-32 px-4 bg-cream watermark-bg" data-id="element-90">
      <div className="max-w-4xl mx-auto" data-id="element-91">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-20" data-id="element-92">
          <span className="inline-block text-gold font-semibold text-xs tracking-[0.2em] uppercase mb-4" data-id="element-93">
            The Unique Mechanism
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-navy mb-6" data-id="element-94">
            Turn The Noise Into
            <br className="hidden md:block" data-id="element-95" /> A Clear Next Step.
          </h2>
          <p className="text-navy/60 text-lg max-w-2xl mx-auto" data-id="element-96">
            The 3-Filter Framework — a repeatable, 5-minute system grounded in
            neuroscience, biblical wisdom, and practical action.
          </p>
        </motion.div>

        <div className="space-y-8" data-id="element-97">
          {steps.map((step, i) => {
          const Icon = step.icon;
          return <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="bg-white p-8 md:p-10 rounded-2xl shadow-sm border border-navy/5" data-id="element-98">
                <div className="flex flex-col md:flex-row md:items-start gap-6" data-id="element-99">
                  <div className="flex-shrink-0 flex items-start gap-4" data-id="element-100">
                    <span className="text-6xl font-bold text-navy/[0.05] font-serif leading-none" data-id="element-101">
                      {step.number}
                    </span>
                    <div className="w-12 h-12 rounded-xl bg-navy/5 flex items-center justify-center" data-id="element-102">
                      <Icon className={`w-6 h-6 ${step.colorClasses.icon}`} data-id="element-103" />
                    </div>
                  </div>
                  <div className="flex-1" data-id="element-104">
                    <div className="flex flex-wrap items-center gap-3 mb-3" data-id="element-105">
                      <span className={`text-xs font-bold tracking-[0.15em] uppercase px-3 py-1 rounded-full border ${step.colorClasses.badge}`} data-id="element-106">
                        {step.label}
                      </span>
                      <span className="text-navy/40 text-sm" data-id="element-107">{step.time}</span>
                    </div>
                    <h3 className="text-2xl font-bold text-navy mb-3" data-id="element-108">
                      {step.title}
                    </h3>
                    <p className="text-navy/70 leading-relaxed" data-id="element-109">{step.desc}</p>
                  </div>
                </div>
              </motion.div>;
        })}
        </div>

        <div className="text-center mt-14" data-id="element-110">
          <CTAButton mainText="GET THE FRAMEWORK — $17.95" large data-id="element-111" />
        </div>
      </div>
    </section>;
}